import { IPortfolioMetadata, IAccountMetadata } from "@pulse-ui/codegen/generated_ts/org_metadata";
import { IAGPortfolioDataRow, IAGAccountDataRow } from "@pulse-ui/types/components/AGTable";

/**
 * Transforms portfolio metadata from API response to AG Grid row format
 */
export const parsePortfolioToRow = (
    portfolio: IPortfolioMetadata
): IAGPortfolioDataRow => {
    return {
        row_id: portfolio.portfolio_id,
        portfolio_id: portfolio.portfolio_id,
        display_name: portfolio.display_name,
        created: portfolio.created,
        last_modified: portfolio.last_modified || "-",
        accounts: [],
    };
};

/**
 * Transforms account metadata from API response to AG Grid row format
 */
export const parseAccountToRow = (
    account: IAccountMetadata,
    portfolioId: string | null
): IAGAccountDataRow => {
    return {
        row_id: account.account_id,
        account_id: account.account_id,
        display_name: account.display_name,
        created: account.created,
        last_modified: account.last_modified || "-",
        portfolio_id: portfolioId,
    };
};
